"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var i18next_1 = require("i18next");
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var Category_less_1 = __importDefault(require("./Category.less"));
var Category = function (_a) {
    var icon = _a.icon, label = _a.label, children = _a.children;
    return (react_1.default.createElement("div", { className: Category_less_1.default['category'] },
        react_1.default.createElement("div", { className: Category_less_1.default['heading'] },
            react_1.default.createElement(react_2.default, { className: Category_less_1.default['icon'], name: icon }),
            react_1.default.createElement("div", { className: Category_less_1.default['label'] }, (0, i18next_1.t)(label))),
        children));
};
exports.default = Category;
